import React, { useContext } from 'react';
import _ from 'lodash';

import { withRouter } from 'react-router-dom';
import AppContext from '../../AppContext';
import { routes } from '../../routes';
import styles from './style.module.scss';
import {
  FluidPrimaryButton,
  If,
  PrimaryButton,
  SpacingBox,
} from '../../Components';
import {
  getCurrentOrder,
  getDeliveryDataForProduct,
  getProductForNumber,
  getSeasonForProduct,
} from '../../selectors';
import { generateProductId } from '../../utils/products';
import { translate } from './translate';
import { onAddAllProducts } from '../../utils/onAddAllProducts';

const addSelectedProductsToast = (context, history) =>
  context.actions.setToast({
    title: translate('multipleProductsAdded.title'),
    text: translate('multipleProductsAdded.description'),
    action: {
      text: translate('toCurrentOrderText'),
      onClick: () => history.push(routes.currentOrder),
    },
  });

export const onAddSelectedProducts =
  (multiSelectItems, tischOffensiveId, context, currentOrder, history, onAdd) =>
  () => {
    const selectedProducts = multiSelectItems.map((number) => {
      const { includesDeliveryPeriod, defaultDeliveryDate } =
        getDeliveryDataForProduct(context, number);

      const product = getProductForNumber(context)(number);

      return {
        id: generateProductId(),
        number,
        tischOffensiveId,
        createdAt: new Date(),
        deliveryDate: includesDeliveryPeriod ? defaultDeliveryDate : null,
        season: getSeasonForProduct({
          number: product.n,
          orderSeason: currentOrder.doc.season,
          context,
        }),
      };
    });
    console.log(selectedProducts);
    context.actions.onAddMultipleProductsToOrder({
      order: currentOrder.doc,
      products: selectedProducts,
      onSuccess: () => addSelectedProductsToast(context, history),
    });
    onAdd();
  };

export const AddMultipleItems = withRouter(
  ({
    multiSelectItems,
    tischOffensiveId,
    history,
    onAdd,
    isAddAllProductsEnabled,
    products,
  }) => {
    const context = useContext(AppContext);
    const currentOrder = getCurrentOrder(context);

    const handleAddSelectedProducts = onAddSelectedProducts(
      multiSelectItems,
      tischOffensiveId,
      context,
      currentOrder,
      history,
      onAdd
    );

    const handleAddAllProducts = () =>
      onAddAllProducts({
        products,
        tischOffensiveId,
        context,
        currentOrder,
        history,
        onAdd,
      });

    return (
      <div className={styles.addToCart}>
        <If condition={_.size(multiSelectItems)}>
          {() => (
            <>
              <FluidPrimaryButton
                onClick={handleAddSelectedProducts}
                text={`${translate('addToCart')} (${_.size(multiSelectItems)})`}
              />
              <SpacingBox marginLeft='md'>
                <FluidPrimaryButton
                  onClick={() => onAdd()}
                  text={translate('clear')}
                />
              </SpacingBox>
            </>
          )}
        </If>

        <If condition={isAddAllProductsEnabled}>
          {() => (
            <SpacingBox marginLeft='md'>
              <PrimaryButton
                onClick={handleAddAllProducts}
                text={translate('addAllItemsToCart')}
              />
            </SpacingBox>
          )}
        </If>
      </div>
    );
  }
);
